import React from "react";
import { OpenButton, Wrap } from "./styles";
import CheckBox, {
  CheckBoxProps,
} from "components/foundation/CheckBox/CheckBox";
import { RightIcon } from "assets/icons";

interface ConsentItemProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  checked: boolean;
  onCheckedChange: CheckBoxProps["onCheckedChange"];
  onClickOpenModal?: React.MouseEventHandler;
}

const ConsentItem = ({
  label,
  checked,
  onCheckedChange,
  onClickOpenModal,
  ...rest
}: ConsentItemProps) => {
  return (
    <Wrap {...rest}>
      <CheckBox checked={checked} onCheckedChange={onCheckedChange}>
        {label}
      </CheckBox>

      <OpenButton onClick={onClickOpenModal}>
        <RightIcon />
      </OpenButton>
    </Wrap>
  );
};

export default ConsentItem;
